// import SkuItem from './item'
import listComponent from '@/util/proto/listComponent'
// import SkuInstallment from './installment'
import Item from './item'

const goodsSpecConv = (data)=>{
  let ret = ''
  try{
    let json = JSON.parse(data)
    ret = json.map(i=>(i.specKey)).join(' , ')
    // ret = json.map(i=>(i.specName+'：'+i.specKey)).join(' , ')
  }catch(e){}
  return ret
}

export const MiniSku = {
  extends: listComponent,
  props:{
    records:{
      type:Array,
      default(){
        return []
      }
    },
  },
  data() {
    return {
      columns: [
        {title:'SKU名称', key:'name'},
        {title:'SKU编码', key:'code'},
        {title:'规格',key:'specText'},
        {title:'条形码', key:'barCode'},
        {title:'建议零售价', key:'referencePrice'},
        {title:'实际价格', key:'salePrice'},
       
      ],
      data: [],
    
      loading: false,
      visible:false,
      id:null,
    }
  },

 
  render(){
    const data = this.records || []
    return <sl-table show-header={true} loading={this.loading} columns={this.columns} data={data} />
  }
}

export default {
  extends: listComponent,
  props:{
    goodsId:null
  },
  data() {
    return {
      columns: [
        {title:'SKU名称', key:'name'},
        {title:'SKU编码', key:'code'},
        {title:'规格',key:'specText'},
        {title:'条形码', key:'barCode'},
        {title:'建议零售价', key:'referencePrice'},
        {title:'实际价格', key:'salePrice'},
        {
          title: '操作',
          key: 'operation',
          width: 120,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            
            let acts = [
            ]
           
            acts.push(
              <a on-click={()=>this.edit(row)}>编辑</a>,
              <a on-click={()=>this.remove(row)}>删除</a>
            )

            return this.$utils.link(acts,<Divider type="vertical" />)
          }
        }
      ],
      data: [],
      params: {
        goodsId:undefined
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      visible:false,
      id:null,
      specs:[]
    }
  },

  created() {
    this.def = { ...this.params }
    if(this.goodsId){
      this.init( this.goodsId )
    }
    // this.search()
  },
  computed:{
    importUrl() {
      return this.$request.assPartsGoodsImportUrl()
    }
  },
  methods: {
    init(goodsId){
      this.id = goodsId
      this.visible = true
      this.search()
    },
    search() {
      // let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.goodsSkus(this.id).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data || [], {'spec':goodsSpecConv})
        }
      })

      this.$request.goods(this.id).then(resp => {
        this.specs = resp.data.specs || []
      })
    },
    reset(){
      this.$utils.fill(this.params, this.def)
      this.search()
    },
    edit(record) {
      // this.$refs['item'].init(record.id)

      const close = () => {
        this.search()
        modal.destroy({triggerOk:true})
      }

      const modal = this.$dialog.show({
        title:'编辑SKU',
        width: 850,
        // transitionNames: ['none', 'none'],
        paddingless: true,
        render: () => {
          return <Item skuId={record.id} goodsSpecs={ this.specs} goodsId={this.id} on-update={close} />
        }
      })

    },
    create() {
      const close = () => {
        this.search()
        modal.destroy({triggerOk:true})
      }
      this.$dialog.show({
        title:'新增SKU',
        width: 850,
        // transitionNames: ['none', 'none'],
        paddingless: true,
        render: () => {
          return <Item goodsSpecs={ this.specs} goodsId={this.id} on-update={close} />
        }
      })
    },
    sku(){
      
    },
    toggle(record){
      this.$request.productToggle(record.id).then(resp => {
        if (resp.code) {
          this.$Message.error(resp.msg)
        } else {
          this.$Message.success('操作成功')
          this.search()
        }
      })
    },

    remove(record) {
      this.$ui.confirm(this.$request.productDelete, `确定删除商品 ${record.commodityName}？`)(record.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('删除成功')
          this.search()
        } else {
          this.$Message.error({ content: resp.msg })
        }
      })
    },
    
    handleUpdate() {
      this.search()
    },

    $update() {
      this.search()
    },
    handleImportComplete(resp){
      if(resp.code){
        this.$Modal.warning({title:'配件导入',content:resp.msg})
      }else{
        this.$Notice.success({title:'导入成功' , duration:20, desc:'您可在 基础设置->导入管理 中查看处理结果！'})
      }
      this.search()
    },
   
  },

  render() {
    return (
      <sl-side-panel v-model={this.visible} loading={this.loading} title='编辑SKU'>

        {/* <sl-page> */}

          <div class="page-filter">
            <Button type="primary" class="margin-right" icon="md-add" on-click={this.create}>新增</Button>
          </div>
          <sl-table show-header={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} />
          {/* <SkuItem ref="item" on-on-update={this.handleUpdate} /> */}
          {/* <SkuInstallment ref="itemInstallment" on-on-update={this.handleUpdate} /> */}
        {/* </sl-page> */}
     
      </sl-side-panel>
    )
  }
}
